import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-664b471d")

_pushScopeId("data-v-664b471d")
const _hoisted_1 = { class: "SModal__wrapper" }
const _hoisted_2 = { class: "SModal" }
const _hoisted_3 = { class: "SModal__header" }
const _hoisted_4 = { class: "SModal__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "SModal__layer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, undefined, true)
      ]),
      _createVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "body", {}, undefined, true)
      ])
    ])
  ]))
})